export default "__VITE_ASSET__1050c0ea__"